import { IFAQ, IFAQValidation } from '../types/editFAQ';
import { defaulLangTextValidation, defaultTTranslate } from 'src/constants/main';

export const defaultFAQ: IFAQ = {
  id: 0,
  sort: 0,
  question: defaultTTranslate,
  answer: defaultTTranslate,
  status: 1,
};

export const defaultFAQValidation: IFAQValidation = {
  isValid: true,
  question: defaulLangTextValidation,
  answer: defaulLangTextValidation,
};
